import http from './request'
/* eslint-disable */
var downloadsetTimer = true;
// 用户登陆
export const userMsg = (user) => http.post('/api/authorizations', user)

// 用户登出
export const logout = () => http.get('/api/user/logout')

// 获取设置信息
export const getSettingInfo = (uid) => http.post('/source/noValidation/getInfo', {uid: '111111'})

//获取客户信息设置
export const getUserInfoSet = () => http.get('/source/settings/getInfo')

// 获取当前登录用户信息
export const getUserInfo = () => http.get('/api/user')

// 收藏夹目录
export const folderBox = (type) => http.get('/source/favorite/folderList', null, {params:type})

// 视频收藏夹
// export const videoFolder = (type) => http.get('/source/favorite/folderList', null, {params:type})

// 创建收藏夹
export const addFolder = (folder) => http.post('/source/favorite/add', folder)

// 删除收藏夹
export const deleteFolder = (id) => http.delete('/source/favorite/folderDelete', null, {params:id})

// 移动收藏夹资源
export const moveSource = (detail) => http.post('/source/favorite/itemMove', detail)

// 更新收藏夹
export const patchFolder = (fold) => http.patch('/source/favorite/folderUpdate', null, null, {params:fold})

// 获取收藏夹内的资源
export const folderDetail = (id) => http.get('/source/favorite/ItemList/', null, {params:id})

// 删除收藏夹内资源
export const deleteSource = (id) => http.delete('/source/favorite/itemDelete', null, {params:id})

// 下载记录
export const loadTable = (type) => http.get('/source/record/userDownload', null,  {params:type})

// 分页查询
export const pageDevice = (num) => http.get('/source/record/userDownload', null,  {params:num})

// 日期查询
export const dateSearch = (search) => http.get('/source/record/userDownload',null, {params:search})

// 下载申请
// export const loadRequest = (type) => http.get('/source/download/apply/5016498?assetType=' + type)

// 单一下载
export const singleLoad = (id) => http.get('/source/download/single', null, {params:id})

// 打包下载
export const packLoad = (params) =>{
    if(downloadsetTimer){
        downloadsetTimer = false;
        setTimeout(function() {
          downloadsetTimer = true;
        }, 1500);
        return http.get('/source/download/pack', null,  {params:params})
      }
} 

// 供图记录
export const picRecord = (num) => http.get('/source/record/userUpload', null, {params:num})

// 供图记录分页
// export const recordPage = (params) => http.get('/source/record/userUpload', null,  {params:params})

// 供图记录搜索
export const searchRecord = (params) => http.get('/source/record/userUpload', null,  {params:params})

// 组资源的更新???
export const updateSource = (source) => http.patch('/source/group/update', null, null, {params:source})

// 删除组资源
export const deleteGruopSource = (id) => http.delete('/source/group/groupDelete', null, {params:id})

// 获取供图记录组内资源
export const groupSource = (params) => http.get('/source/record/group_resource', null,  {params:params})

// 收藏夹添加资源
export const addCollectFolder = (source) => http.post('/source/favorite/addResource', source)

// 删除资源
export const deleteSingleSource = (id) => http.delete('/source/resource/delete', null, {params:id})

// 资源更新(照片详情页)
export const updateSingleSource = (source) => http.patch('/source/resource/update', source)

// 移动组资源
export const sourceMoveTo = (source) => http.post('/source/group/move', source)

// 复制组资源
export const sourceCopy = (source) => http.post('/source/group/copy', source)

// 根据id获取资源信息
export const sourceMsg = (params) => http.get('/source/resource/detail', null,  {params:params})

// 供稿人组内资源封面设置
export const uploadCover = (source) => http.post('/source/contributor/updateIndex', source)

// 供稿人组内资源追加
export const uploadSourceAdd = (source) => http.post('/source/contributor/resAddTo', source)

// 供稿人组内资源删除
export const deleteUploadSource = (id) => http.delete('/source/contributor/resourceDel', null, {params:id})

// 供稿人组信息编辑
export const updateGroup = (source) => http.post('/source/contributor/groupUpdate', source)

// 供稿人组封面恢复默认
export const recoverGroupPic = (source) => http.post('/source/contributor/resetIndex', source)

// 供稿人组资源整组删除
export const deleteUploadGroup = (id) => http.delete('/source/contributor/groupDel', null, {params:id})

// 供稿人组内资源编辑
export const updateSourceEdit = (source) => http.post('/source/contributor/resourceUpdate', source)

// 获取当前用户基本信息
export const getUser = () => http.get('/api/user')

// 修改当前用户基本信息
export const patchUserMsg = (usermsg) => http.patch('/api/user', null, null, {params:usermsg})

// 修改密码
export const updatePwd = (pwd) => http.post('/api/user/reset_password', pwd)

// Blob
export const getImageBlob = url => http.get(url, undefined, { responseType: 'blob', withCredentials: false })

//上传头像
export const uploadHead = data => http.post('api/user/uploadHead', data)

// 给组资源追加信息
export const addGroupInfo = data => http.post('/source/resource/addGroupContent', data)



// WEBPACK FOOTER //
// ./src/services1/index.js